import { z } from 'zod'

/**
 * Lifecycle of an outbound email. Mirrors `EmailStatus` in the Prisma schema.
 * `queued` is our send to Resend; later values come from the Resend webhook.
 */
export const EMAIL_STATUSES = [
  'skipped',
  'failed',
  'queued',
  'sent',
  'delayed',
  'delivered',
  'opened',
  'clicked',
  'bounced',
  'complained',
] as const

export const emailStatusSchema = z.enum(EMAIL_STATUSES)

export type EmailStatus = z.infer<typeof emailStatusSchema>
